import { CheckSharp, CloseSharp } from '@mui/icons-material'
import { Box, Button, FormControl, FormLabel, Grid } from '@mui/material'
import { CompanyStatusType } from 'api/models/Common/JyrneyEnums'
import { CountryCode } from 'api/models/GetAddress.type'
import { CountrySelect } from 'components/Common/CountrySelect/CountrySelect'
import notifyPopup from 'components/Common/Notification/notifyPopup'
import RadioSwitch from 'components/FormFields/RadioSwitch/RadioSwitch'
import Select from 'components/FormFields/Select/Select'
import Form from 'components/RouteWizard/Form'
import useClient from 'hooks/useClient'
import useClients from 'hooks/useClients'
import useUserRole from 'hooks/useUserRole'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import Input from '../../../FormFields/Input/Input'
import styles from './companyStyle'
import schema from './schema'

function Company(props: any) {
  const client = { ...props.client }

  const { validateAccess } = useUserRole()
  const { options: ClientOptions } = useClients()
  const { updateClient, error } = useClient(client.id)
  const [errors, setErrors] = useState<Record<string, any>>({})
  const initialFormData = {
    contact: { name: '', email: '', contactNumber: '' },
    ...client,
  }
  const [formData, setFormData] = useState(initialFormData)
  const [patchData, setPatchData] = useState({})
  const [editForm, setEditForm] = useState(false)
  const [selectValue, setSelectValue] = useState<number>(client.parentClientId)

  function setDeepValue(obj: any, path: string, value: any) {
    const keys = path.split('.')
    const lastKey = keys.pop()
    const deep = keys.reduce((acc, key) => {
      if (!acc[key]) acc[key] = {}
      return acc[key]
    }, obj)
    if (lastKey !== undefined) {
      deep[lastKey] = value
    }
    return { ...obj }
  }

  function getParentPath(path: string): string {
    const keys = path.split('.')
    keys.pop()
    return keys.join('.')
  }

  function getSiblings(obj: any, parentPath: string) {
    if (!parentPath) return obj
    return parentPath.split('.').reduce((acc, key) => acc?.[key], obj)
  }

  const handleCancel = () => {
    setEditForm(false)
    setFormData(initialFormData)
    setPatchData({})
    setErrors({})
  }

  const onSubmit = () => {
    setEditForm(false)
    updateClient({ data: patchData }, client.id).then(() => {
      notifyPopup({
        type: error ? 'danger' : 'success',
        message: error
          ? 'Update failed to save'
          : 'Details updated successfully',
      })
    })
  }

  const onChange = (eOrValue: any) => {
    let fieldName: string | null = null
    console.log(eOrValue)
    if (eOrValue && eOrValue.target) {
      const { name, value } = eOrValue.target as any
      console.log({ name, value })
      const parentPath = getParentPath(name)
      const siblings = getSiblings(formData, parentPath)
      fieldName = name
      if (fieldName) {
        setFormData((prev: any) =>
          setDeepValue(
            { ...prev },
            name,
            fieldName === 'parentClientId' ? Number(value) : value,
          ),
        )
      }
      if (fieldName === 'parentClientId') {
        setSelectValue(value === '' ? 0 : Number(value))
      }
      if (parentPath) {
        setPatchData((prev: any) =>
          setDeepValue({ ...prev }, parentPath, {
            ...siblings,
            [name.split('.').pop()!]:
              name === 'parentClientId' ? Number(value) : value,
          }),
        )
      } else {
        setPatchData((prev: any) =>
          setDeepValue(
            { ...prev },
            name,
            name === 'parentClientId' ? Number(value) : value,
          ),
        )
      }
    } else if (
      eOrValue &&
      eOrValue.name !== undefined &&
      eOrValue.value !== undefined
    ) {
      fieldName = eOrValue.name
      setFormData((prev: any) =>
        setDeepValue({ ...prev }, eOrValue.name, eOrValue.value),
      )
    } else if (typeof eOrValue === 'string') {
      fieldName = 'address.countryCode'
      let updated = setDeepValue(
        { ...formData },
        'address.countryCode',
        eOrValue,
      )
      updated = setDeepValue(
        updated,
        'address.country',
        CountryCode[eOrValue as keyof typeof CountryCode] || '',
      )
      setFormData(updated)

      setPatchData((prev: any) => {
        const siblings = formData.address || {}
        return setDeepValue({ ...prev }, 'address', {
          ...siblings,
          countryCode: eOrValue,
          country: CountryCode[eOrValue as keyof typeof CountryCode] || '',
        })
      })
    }

    // Clear error for this field
    if (fieldName && errors[fieldName]) {
      setErrors((prev) => ({ ...prev, [fieldName]: undefined }))
    }
  }

  useEffect(() => {
    console.log('changedFormData', formData)
  }, [formData])
  useEffect(() => {
    console.log('changedPatchData', patchData)
  }, [patchData])

  return (
    <Form
      schema={schema}
      onSubmit={onSubmit}
      defaultValues={formData}
      showControls={false}
    >
      <Grid container sx={{ ...styles.componentPanel }}>
        <Grid container sx={styles.leftHeading}>
          <Grid item xs={12} sm={8}>
            <FormLabel>Company</FormLabel>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input
            name="companyName"
            label="Company Name"
            value={formData.companyName || ''}
            onChange={onChange}
            InputLabelProps={{
              shrink: true,
            }}
            disabled={!editForm}
          />
          {(formData.alias || editForm) && (
            <Input
              name="alias"
              label="Trading As"
              onChange={onChange}
              value={formData.alias}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={!editForm}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={8}>
          <Input
            name="registrationNumber"
            label="Registration Number"
            value={formData.registrationNumber}
            onChange={onChange}
            InputLabelProps={{
              shrink: true,
            }}
            disabled={!editForm}
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <Select
            name="parentClientId"
            label="Parent Client"
            options={ClientOptions}
            onChange={onChange}
            value={
              selectValue === undefined || isNaN(Number(selectValue))
                ? ''
                : selectValue
            }
            disabled={!editForm}
            style={{ maxWidth: '250px' }}
          />
        </Grid>
        <Grid container sx={{ marginTop: '20px' }}>
          <Grid container sx={{ width: '40%', alignContent: 'flex-start' }}>
            <Grid item xs={12} sm={8}>
              <FormLabel sx={styles.leftHeading}>Address</FormLabel>
            </Grid>
            <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
              <Input
                name="address.addressLine1"
                label="Address Line 1"
                value={formData.address.addressLine1}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>

            {formData.address.addressLine2 || editForm ? (
              <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
                <Input
                  name="address.addressLine2"
                  label="Address Line 2"
                  value={formData.address.addressLine2}
                  onChange={onChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={!editForm}
                />
              </Grid>
            ) : null}

            {formData.address.addressLine3 || editForm ? (
              <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
                <Input
                  name="address.addressLine3"
                  label="Address Line 3"
                  value={formData.address.addressLine3}
                  onChange={onChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={!editForm}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
              <Input
                name="address.town"
                label="Town"
                value={formData.address.town}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
              <Input
                name="address.county"
                label="County"
                value={formData.address.county}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
              <Input
                name="address.postcode"
                label="Post / Zip Code"
                value={formData.address.postCode}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={10}>
              <FormControl variant="outlined" sx={{ display: 'none' }}>
                <Input
                  label="Country"
                  name="address.country"
                  onChange={onChange}
                  disabled={!editForm}
                  value={formData.address.country || ''}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={10} sx={styles.fieldSpacing}>
              <CountrySelect
                label="Country"
                name="address.countryCode"
                onChange={onChange}
                disabled={!editForm}
                value={formData.address.countryCode}
                sibling="address.country"
                width="100%"
              />
            </Grid>
          </Grid>
          <Grid container sx={{ width: '40%', alignContent: 'flex-start' }}>
            <Grid item xs={12} sm={8}>
              <FormLabel>Company Contact</FormLabel>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Input
                name="contact.name"
                label="Contact Name"
                value={formData.contact.name || ''}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Input
                name="contact.email"
                label="Contact Email"
                value={formData.contact.email || ''}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <Input
                name="contact.contactNumber"
                label="Contact Phone Number"
                value={formData.contact.contactNumber || ''}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          {validateAccess('JYRNEY_ADMIN') && (
            <>
              <Box
                sx={{
                  width: '67%',
                  bgcolor: 'background.paper',
                  borderRadius: '4px',
                  marginTop: '10px',
                  marginRIght: 0,
                }}
              >
                <Box
                  component="div"
                  sx={(theme) => ({
                    width: '100%',
                    backgroundColor: theme.palette.brand.main,
                    color: theme.palette.common.white,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '5px',
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  })}
                >
                  <h3>ADMIN PANEL</h3>
                </Box>
                <Grid container sx={{ paddingX: '40px', paddingY: '20px' }}>
                  <Box sx={{ display: 'flex', width: '100%' }}>
                    <RadioSwitch
                      name="status"
                      label="Client Status"
                      value={formData.status}
                      disabled={!editForm}
                      onChange={editForm ? onChange : () => {}}
                      options={Object.entries(CompanyStatusType).map((s) => {
                        return { label: s[1], value: s[0] }
                      })}
                    />
                  </Box>
                  <Grid item xs={12} sm={8}>
                    <Input
                      name="commission"
                      label="Commission %"
                      value={formData.commission || ''}
                      onChange={onChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={!editForm}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Input
                      name="markup"
                      label="Markup %"
                      value={formData.markup || ''}
                      onChange={onChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={!editForm}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      paddingTop: '10px',
                    }}
                  >
                    Managed Client
                    {formData.settings.isManaged ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    Billed from Parent
                    {formData.settings.isBilledFromParent ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    Automatic Allocation
                    {formData.settings.automaticAllocation ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    Automatic Reallocation
                    {formData.settings.automaticReallocation ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    Apply Destination Logic
                    {formData.settings.applyDestinationLogic ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    Apply Backup Vehicle Logic
                    {formData.settings.applyBackupVehicleLogic ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    Fixed Pricing
                    {formData.settings.applyFixedPricing ? (
                      <CheckSharp
                        color="success"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    ) : (
                      <CloseSharp
                        color="error"
                        fontSize="small"
                        sx={{ marginLeft: '10px' }}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      marginTop: '10px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>Client Type:</Box>
                    <Box> {formData.clientTypeName}</Box>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ ...styles.fieldSpacing, width: '70%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            marginTop: '20px',
            gap: '10px',
          }}
        >
          <Button
            color={!editForm ? 'primary' : 'error'}
            onClick={() => {
              if (editForm) {
                handleCancel()
              } else {
                setEditForm(true)
              }
            }}
          >
            {!editForm ? 'Edit' : 'Cancel'}
          </Button>
          {editForm && <Button type="submit">Save</Button>}
        </Box>
      </Grid>
    </Form>
  )
}

Company.propTypes = {
  client: PropTypes.object.isRequired,
}

export default Company
